module.exports = __webpack_public_path__ + "img/change-this.5218c7fc.png";